{
  "es": {
    "employee": {
      "actions": {
        "accessProjects": "Gestionar acceso a proyectos",
        "cancel": "Deshacer",
        "changeProfilePicture": "Cambiar foto de perfil",
        "download": "Descargar",
        "new": "Empleado",
        "profilePictureFormat": "Debe medir al menos 300x300px",
        "save": "Guardar",
        "searchEmployee": "Buscar empleado",
        "sendinvitation": "Crear y enviar invitación",
        "submit": "Guardar",
        "undoChanges": "Deshacer"
      },
      "attributes": {
        "email_address": "Correo electrónico",
        "email_notifications_interval": {
          "daily": "Una vez al día (alrededor del mediodía)",
          "hourly": "Cada hora",
          "twice_daily": "Dos veces al día (mañana/mediodía)",
          "weekly": "Una vez a la semana (lunes al mediodía)"
        },
        "first_name": "Nombre",
        "language": "Idioma",
        "last_name": "Apellidos",
        "phone_landline": "Número de teléfono fijo",
        "phone_mobile": "Número de móvil",
        "profession": "Cargo",
        "role": "Permisos de acceso",
        "signature_html": "Firma de la conversación",
        "status": "Estado",
        "title": "Tratamiento"
      },
      "billing": {
        "contact_us": "Contáctanos",
        "contact_us_message": "Hola, me gustaría cambiar el paquete de {client_name}.",
        "gigabytes": "{amount} GB",
        "in_use": "/ {total} en uso",
        "manage_members": "Gestionar miembros",
        "package": "Paquete",
        "package_help_mup": "¿Buscas proyectos o almacenamiento extra, o quieres cambiar de plan?",
        "package_help_sup": "¿Buscas proyectos, plazas o almacenamiento extra, o quieres cambiar de plan?",
        "plan_renamed": "Hemos introducido nuevos planes, así que es posible que el nombre que ves aquí no coincida con tu suscripción actual. Contáctanos para saber más sobre los nuevos planes.",
        "projects": "Proyectos",
        "projects_available": "Todos los proyectos en uso | 1 proyecto disponible | {count} proyectos disponibles",
        "seats": "Plazas",
        "seats_active": "/ {total} activas",
        "seats_package": "Ninguna plaza en tu paquete | 1 plaza en tu paquete | {count} plazas en tu paquete",
        "seats_paying": "+ 1 plaza extra de pago | + {count} plazas extra de pago",
        "storage": "Almacenamiento",
        "storage_available": "{amount} GB disponibles",
        "storage_total": "/ {amount} GB",
        "units": "Unidades",
        "units_available": "Todas las unidades en uso | 1 unidad disponible | {count} unidades disponibles"
      },
      "integrations": {
        "hide_details": "Ocultar detalles",
        "last_synced_at": "Última sincronización: {time}",
        "show_details": "Mostrar detalles"
      },
      "labels": {
        "all_projects": "Todos los proyectos",
        "confirmPasswordReset": "Se ha enviado un correo con un enlace para restablecer tu contraseña; revisa tu bandeja de entrada. Contáctanos si tienes algún problema.",
        "disabled": {
          "access": "Daremos acceso a la plataforma a todos los empleados en cuanto se pague la última factura vencida.",
          "contact": "Contáctanos",
          "overdue": "Hemos detectado que tu última factura lleva mucho tiempo vencida. Hemos revocado el acceso a todos los empleados de esta plataforma. Los colaboradores y clientes seguirán pudiendo acceder a sus datos.",
          "title": "¡Tu cuenta ha sido desactivada!"
        },
        "display": "Visualización",
        "filters": "Filtros",
        "generalNotifications": "Notificarme sobre",
        "has_access_to": "Tiene acceso a",
        "information": "Información del perfil",
        "informationNotificationsEmail": "Recibe una vista general por correo con las notificaciones que aún no has visto en la plataforma.",
        "informationNotificationsPlatform": "Recibe todas las notificaciones en tu vista general personal, en la parte superior derecha de la pantalla.",
        "informationNotificationsTitle": "Decide qué tipo de notificaciones quieres recibir y cómo",
        "its_you!": "¡Eres tú!",
        "maintainerAccess": "Acceso concedido por proyecto.",
        "name": "Nombre",
        "onPlatform": "En la plataforma",
        "ownerAccess": "Acceso a todos los proyectos y contenidos, además de la facturación y la gestión del equipo.",
        "password": "Contraseña",
        "permissions": "Permisos de acceso para",
        "permissionsOwnerOnly": "Como mantenedor de proyecto no puedes realizar esta acción. Pide a un empleado de {client_name} con el rol de propietario que lo haga por ti.",
        "projectMaintains": "{first_name} tiene acceso a los siguientes proyectos:",
        "projectMaintainsAdd": "Para conceder acceso, selecciona un proyecto y añade a {first_name} como mantenedor de proyecto en la función Información.",
        "projectMaintainsNone": "no tiene acceso a ningún proyecto.",
        "projectNotifications": "Para el proyecto",
        "search_by_name_or_email": "Buscar por nombre o correo",
        "show_signature": "Mostrar firma",
        "signature_active": "Firma activa",
        "signature_info": "Esta firma se añadirá a las respuestas enviadas a clientes y colaboradores.",
        "sorting": "Orden",
        "viaEmail": "Por correo"
      },
      "modals": {
        "maintainers_access": {
          "accessible": "Accesible",
          "description": "Los cambios se guardan automáticamente",
          "not_accessible": "No accesible",
          "title": "Actualizar accesibilidad del proyecto para {first_name} {last_name}"
        }
      },
      "roles": {
        "maintainer": "Mantenedor",
        "owner": "Propietario"
      },
      "team": {
        "actions": {
          "activate": "Activar",
          "cancel_invitation": "Cancelar invitación",
          "deactivate": "Desactivar",
          "invite": "Invitar",
          "make_maintainer": "Hacer mantenedor",
          "make_owner": "Hacer propietario",
          "remove": "Quitar del equipo"
        },
        "dialogs": {
          "activate_body": "{name} vuelve a tener acceso completo a la plataforma.",
          "activate_body_pending": "{name} vuelve a Pendiente y pasa a estar activo al iniciar sesión con su invitación.",
          "activate_body_seat": "{name} vuelve a tener acceso completo a la plataforma. Esto usa una plaza.",
          "activate_confirm": "Activar",
          "activate_title": "¿Activar a {name}?",
          "cancel_invitation_body": "{name} ya no podrá unirse con la invitación recibida.",
          "cancel_invitation_confirm": "Cancelar invitación",
          "cancel_invitation_title": "¿Cancelar la invitación?",
          "contact_us": "Contáctanos",
          "contact_us_message": "Hola, me gustaría añadir más plazas para {client_name}.",
          "deactivate_body": "{name} conserva su cuenta pero pierde el acceso a la plataforma.",
          "deactivate_body_seat": "{name} conserva su cuenta pero pierde el acceso a la plataforma. Esto libera una plaza.",
          "deactivate_confirm": "Desactivar",
          "deactivate_title": "¿Desactivar a {name}?",
          "demote_body": "{name} pierde el acceso a todos los proyectos hasta que se lo des, y ya no puede gestionar la facturación ni el equipo.",
          "demote_confirm": "Hacer mantenedor",
          "demote_title": "¿Hacer mantenedor a {name}?",
          "owner_wall_banner": "Tu organización siempre debe tener al menos un propietario activo.",
          "owner_wall_body_deactivate": "Reactiva o asciende a otro propietario antes de desactivar a {name}.",
          "owner_wall_body_demote": "Reactiva o asciende a otro propietario antes de cambiar el rol de {name}.",
          "owner_wall_body_remove": "Reactiva o asciende a otro propietario antes de quitar a {name}.",
          "owner_wall_title": "Acción bloqueada",
          "promote_body": "{name} obtiene acceso a todos los proyectos y puede gestionar la facturación y el equipo.",
          "promote_confirm": "Hacer propietario",
          "promote_title": "¿Hacer propietario a {name}?",
          "remove_body": "{name} pierde el acceso y sale de la lista de miembros. No se puede deshacer, pero puedes volver a invitarle más tarde.",
          "remove_body_seat": "{name} pierde el acceso y sale de la lista de miembros. No se puede deshacer, pero puedes volver a invitarle más tarde. Esto libera una plaza.",
          "remove_confirm": "Quitar",
          "remove_title": "¿Quitar a {name} del equipo?",
          "seats_full_banner": "Tu única plaza está en uso. | Las {total} plazas están en uso.",
          "seats_full_body": "Desactiva a un miembro activo para liberar una plaza, o contáctanos para añadir más plazas.",
          "seats_full_invite_body": "Necesitas una plaza disponible para invitar a alguien. Desactiva a un miembro activo, o contáctanos para añadir más plazas.",
          "seats_full_invite_title": "Te has quedado sin plazas",
          "seats_full_title": "No hay plazas disponibles"
        },
        "invite_incomplete": "Rellena el nombre, los apellidos y el correo para enviar la invitación.",
        "invite_note": "Se activan en cuanto crean una cuenta e inician sesión.",
        "invite_note_seats": "En cuanto creen una cuenta e inicien sesión, se activan y usan tu última plaza disponible. | En cuanto creen una cuenta e inicien sesión, se activan y usan una de tus {count} plazas disponibles.",
        "invite_sent": "Invitación enviada",
        "invited_at": "Invitado: {when}",
        "last_active": "Última actividad",
        "manage_in_billing": "Gestionar en Facturación",
        "resend_wait": "Puedes reenviar la invitación 15 minutos después de la anterior.",
        "role": "Rol",
        "seat_states": "Estados de las plazas",
        "seat_states_help": {
          "active": "Acceso completo, usa una plaza. Propietarios y mantenedores.",
          "inactive": "La cuenta existe, sin acceso a la plataforma. Libera la plaza.",
          "pending": "Invitado, aún sin cuenta. No usa plaza."
        },
        "seat_usage": "Uso de plazas",
        "seats_available": "No hay plazas disponibles — desactiva a un miembro o contáctanos | 1 plaza disponible | {count} plazas disponibles",
        "seats_rule": "Solo un propietario puede activar a un miembro, y solo mientras haya una plaza disponible.",
        "seats_total": "/ {total} plaza activa | / {total} plazas activas",
        "statuses": {
          "active": "Activo",
          "inactive": "Inactivo",
          "pending": "Pendiente"
        }
      },
      "toasts": {
        "create": "Empleado creado",
        "update": "Empleado actualizado"
      },
      "validation": {
        "emailTaken": "Este correo ya se ha utilizado",
        "mustBeEmailAddress": "Se requiere un correo válido",
        "needFirstName": "El nombre es obligatorio",
        "needLastName": "Los apellidos son obligatorios",
        "requireEmailAddress": "El correo es obligatorio",
        "role": "Selecciona los permisos de acceso"
      }
    }
  }
}
